import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSkip"><Path d="M19.25 4.75V19.25M7.12185 18.9713L15.2912 13.206C16.1287 12.615 16.1287 11.3851 15.2912 10.7941L7.12186 5.02867C6.12906 4.32801 4.75 5.0292 4.75 6.23465V17.7653C4.75 18.9708 6.12905 19.672 7.12185 18.9713Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSkip;
